import React from 'react'

const styles = {
  statusBadge: {
    fontFamily: "'Courier New', 'Monaco', monospace",
    fontSize: '20px',
    borderRadius: '4px',
    borderWidth: "1px",
    borderStyle: 'solid',
    padding: "2px 6px 1px",
    display: "inline-block",
    margin: "4px 0 0 10px",
    verticalAlign: "top"
  },
  approved: {
    color: '#006600',
    borderColor: '#006600',
  },
  closed: {
    color: '#0011ee',
    borderColor: '#0011ee'
  },
  pending: {
    borderColor: '#ddaa00',
    color: '#ddaa00',
  },
  rejected: {
    borderColor: '#dd0000',
    color: '#dd0000',
  },
  unsaved: {
    borderColor: '#cccccc',
    color: '#bbbbbb',
  }
}

export default function POStatusBadge({purchaseOrder}) {
  return purchaseOrder ? (
    <div style={{
      ...styles.statusBadge,
      ...(styles[purchaseOrder.status])
    }}>{purchaseOrder.status ? purchaseOrder.status.toUpperCase() : 'LOADING'}</div>
  ) : null;
}
